import { useTranslation } from 'react-i18next';
import { Flex, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import Layout from 'components/Layout/Layout';
import SuccessFooter from 'components/Layout/Footer/SuccessFooter';

function SuccessPage() {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('(max-width: 780px)');

  return (
    <Layout t={t} title={t('header.title.success')} isMobile={isMobile}>
      <Flex w={'100%'} justify={'center'} mt={10} mb={40}>
        <Text style={{ fontSize: 20 }} >{t('submission.success')}</Text>
      </Flex>
      <SuccessFooter t={t} />
    </Layout>
  )
}

export default SuccessPage;